module.exports = __webpack_public_path__ + "static/media/empty-dashboard.41a958eb.svg";